var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVenue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F2F2F2;}\n\t.st1{fill:none;stroke:#006DF0;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st2{fill:none;stroke:#37CE93;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st3{fill:none;stroke:#006DF0;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st4{fill:none;stroke:#006DF0;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st5{fill:#006DF0;}\n\t.st6{fill:#37CE93;}\n\t.st7{fill:none;stroke:#006DF0;stroke-width:3;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st8{fill:none;stroke:#37CE93;stroke-width:3;stroke-miterlimit:10;}\n\t.st9{fill:none;stroke:#006DF0;stroke-width:2.5;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st10{fill:none;stroke:#006DF0;stroke-width:3;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M89.08,85.07c-0.38,0.28-0.85,0.45-1.36,0.45H12.41c-0.53,0-1.01-0.19-1.4-0.49c-2.06,0.71-3.2,1.48-3.2,2.29 c0,3.31,18.88,6,42.18,6s42.18-2.69,42.18-6C92.18,86.53,91.07,85.77,89.08,85.07z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st10",
    x1: 16.03,
    y1: 77.92,
    x2: 16.03,
    y2: 32.24
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M60.62,57.27c0-5.86-4.75-10.61-10.61-10.61S39.4,51.41,39.4,57.27v20.65h21.23V57.27z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M55.3,77.92V57.87c0-2.92-2.37-5.29-5.29-5.29s-5.29,2.37-5.29,5.29v20.05"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M85.94,72.94c3.08-1.28,5.19-4.76,5.19-8.45c0-5.23-4.24-9.47-9.47-9.47c-5.23,0-9.47,4.24-9.47,9.47 c0,3.71,2.13,6.92,5.23,8.47c0,0,1.4,0.77,1.69,1.8l2.54,6.31l2.54-6.31C84.2,74.77,84.82,73.41,85.94,72.94z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 81.66,
    cy: 64.8,
    r: 3.68
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 23.34,
    y: 39.48,
    className: "st1",
    width: 9.19,
    height: 9.19
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.49,
    y: 39.48,
    className: "st1",
    width: 9.19,
    height: 9.19
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.34,
    y: 58.62,
    className: "st1",
    width: 9.19,
    height: 9.19
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M68.21,63.82c0-1.19,0.17-2.33,0.45-3.43v-0.32h0.08c0.29-1.02,0.69-1.98,1.19-2.89h-2.72 c-0.8,0-1.44,0.65-1.44,1.44v9.19c0,0.8,0.65,1.44,1.44,1.44h2.08C68.62,67.57,68.21,65.72,68.21,63.82z"
  })), /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "57.34,8.8 86.17,8.8 88.46,28.26 65.16,28.26 50.01,6.67 34.86,28.26 11.55,28.26 13.85,8.8  42.68,8.8  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M82.54,32.24v19.01c0.99,0.01,2.15,0.13,3.08,0.35V32.24H82.54z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M78.52,82.8h-65.4v-3.31H77.2c-0.6-1.31-1.89-2.38-1.89-2.38c-0.32-0.18-0.64-0.39-0.95-0.63h-62.8 c-0.8,0-1.44,0.65-1.44,1.44v6.45c0,0.8,0.65,1.44,1.44,1.44h68.13L78.52,82.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M89.28,75.76c0.38,0.26,0.75,0.82,0.75,1.31v7.41c0,0.8-0.77,1.32-1.56,1.32h-3.78l0.68-3.02h1.66v-4.4 C87.02,78.4,88.3,75.19,89.28,75.76z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVenue);
export default __webpack_public_path__ + "static/media/Venue.f1fd72deebd7f7d4f2f57e2548bb42b6.svg";
export { ForwardRef as ReactComponent };